
import type Vue from 'vue'
import type { ExplainMessages } from '../../models'
import { defineComponent, getCurrentInstance } from 'vue'
import useExplainKpis from '../../composables/explain/use-explain-kpis'
import { KpiEnum } from '../../enums'
import { FeatureIdEnum } from '../../enums/feature-id.enum'
import { ROUTER_CONSTS } from '../../router/router.consts'
import { UiTooltip } from '../keen-ui'
import { EpbBadge } from '../shared/epb-badge'
import EpbButton from '../shared/epb-button/epb-button.component.vue'

export default defineComponent({
  name: 'ExplainQueryMetrics',
  components: {
    EpbBadge,
    EpbButton,
    UiTooltip,
  },
  setup() {
    const {
      proxy: { $router, $epb },
    } = getCurrentInstance() as { proxy: Vue }

    function onClick(): void {
      $router.push({
        name: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].queryAnalysis,
      })
    }

    const messages = $epb.messages.explain as ExplainMessages

    const { getVisibleAndSortedKpiConfigs } = useExplainKpis()

    const visibleKpisInOrder = [KpiEnum.QUERIES, KpiEnum.ADD2CART, KpiEnum.CONVERSION]

    const getKpiTooltip = (kpiLabel: string): string => {
      return $epb.utils.compileMessage(messages.header.metricsTooltip, {
        kpi: kpiLabel,
      })
    }

    return {
      baseClass: 'epb-explain-query-metrics',
      visibleKpisInOrder,
      getVisibleAndSortedKpiConfigs,
      onClick,
      getKpiTooltip,
    }
  },
})
